const COMPONENT_EVENTS = {
  PageLoaded: {
    description: 'Triggered when user loads page',
    eventHub: {
      code: 'PAGE_LOADED',
      action: 'PageLoaded'
    }
  },
  Click: {
    description: 'Triggered when user clicks continue button',
    eventHub: {
      code: 'Click',
      action: 'Clicked'
    }
  }
};

const createEventAction = (eventAction, componentName) => {
  return [`${componentName ?? ''}`, `${eventAction ?? ''}`].filter((str) => !!str).join('_');
};

module.exports = {
  aipWithdrawalApplicationComponentEvents: {
    WithdrawalGateway: {
      code: 'AIPWITHDRAWALGATEWAY',
      events: {
        Click: {
          description: 'Triggered when user clicks on AIP Withdrawal Gateway Info Icon',
          eventHub: {
            code: 'CLICK',
            action: createEventAction('Clicked', 'AIPWithdrawals_AIPinfo')
          }
        },
        Load: {
          description: 'Triggered when info popup load',
          eventHub: {
            code: 'LOAD',
            action: createEventAction('Loaded', 'AIPWithdrawals_AIPinfo')
          }
        },
        LinkClick: {
          description: 'Triggered when user clicks AIP withdrawal link',
          eventHub: {
            code: 'LINKCLICK',
            action: createEventAction('Clicked', 'AIPWithdrawals_AIPCTA')
          }
        }
      }
    },
    AIPWithdrawalPlanSelection: {
      code: 'AIPWITHDRAWALPLANSELECTION',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPPlanSelect')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPPlanSelect_ContinueCTA')
          }
        }
      }
    },
    AIPWithdrawalBalance: {
      code: 'AIPWITHDRAWALBALANCE',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPBalance')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPBalance_ContinueCTA')
          }
        }
      }
    },
    AIPJointAccountWithdrawal: {
      code: 'AIPJOINTACCOUNTWITHDRAWAL',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPPercent')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPPercent_ContinueCTA')
          }
        }
      }
    },
    AIPWithdrawalBankSelect: {
      code: 'AIPWITHDRAWALBANKSELECT',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPBankAccount')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPBankAccount_ContinueCTA')
          }
        },
        AddBank: {
          description: 'Triggered when user clicks on Add Bank Account',
          eventHub: {
            code: 'ADDBANK',
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPBankAccount_AddBankAccountCTA')
          }
        }
      }
    },
    AIPDeductionLimitRRSP: {
      code: 'AIPDEDUCTIONLIMITRRSP',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPDeductionLimit')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPDeductionLimit_ContinueCTA')
          }
        },
        Link: {
          description: 'Triggred on click of where can I find my deduction limit link',
          eventHub: {
            code: 'LINK',
            action: createEventAction('Clicked', 'AIPDeductionLimit_Link')
          }
        }
      }
    },
    AIPWithdrawalTransferDetails: {
      code: 'AIPWITHDRAWALTRANSFERDETAILS',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPRESPDetails')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPRESPDetails_ContinueCTA')
          }
        }
      }
    },
    AIPWithdrawalReview: {
      code: 'AIPWITHDRAWALREVIEW',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPReview')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Click.description,
          eventHub: {
            code: COMPONENT_EVENTS.Click.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Click.eventHub.action, 'AIPReview_SubmitCTA')
          }
        }
      }
    },
    AIPWithdrawalSuccess: {
      code: 'AIPWITHDRAWALSUCCESS',
      events: {
        Load: {
          description: COMPONENT_EVENTS.PageLoaded.description,
          eventHub: {
            code: COMPONENT_EVENTS.PageLoaded.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PageLoaded.eventHub.action, 'AIPSuccess')
          }
        },
        Done: {
          description: 'Triggered when user clicks on Done button',
          eventHub: {
            code: 'DONE',
            action: createEventAction('Clicked', 'AIPSuccess_Done')
          }
        },
        Apollo: {
          description: 'Triggered when user clicks on Apollo card',
          eventHub: {
            code: 'APOLLO',
            action: createEventAction('Clicked', 'AIPSuccess_Apollo')
          }
        }
      }
    }
  }
};
